export const iconFontAwesomeMedicalHealthCapsules = (
	<i className="fa-solid fa-capsules"></i>
);
